
import { useScroll } from "framer-motion";
import React , {useState} from "react";

const InputField = ({
    title,
    placeholder,
    name,
    value,
    onChange,
    type = "text",
    required = false,
    validation= null,
    maxLength,
    horizontal=true,
     }) => {
    const [error, setError] = useState(null);

    const validateEmail = (email) => {
      return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    };

    const validateTasaEmail = (email) => {
        return /^[a-zA-Z0-9._%+-]+@tasa\.com\.pe$/.test(email);
    };


    const validateLettersOnly = (text) => {
        return /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/.test(text);
    };

    const validateAlphanumeric = (text) => {
        return /^[a-zA-Z0-9\s]*$/.test(text); // Solo letras, números y espacios
    };


    const validatePhone = (phone) => {
        return /^\d{0,9}$/.test(phone); // Solo permite hasta 9 dígitos
    };
    
    const handleChange = (e) => {
        let inputValue = e.target.value;

        if (validation === 'email') {
            if (inputValue === '' || validateEmail(inputValue)) {
                onChange(e);
                setError(null);
            } else {
              onChange(e); 
            }
        } else if (validation === 'email-tasa') {
            if (inputValue === '' || validateTasaEmail(inputValue)) {
                onChange(e);
                setError(null);
            } else {
                onChange(e);
            }
        } else if (validation === 'letters-only') {
            if (inputValue === '' || validateLettersOnly(inputValue)) {
                onChange(e);
                setError(null);
            }
        } else if (validation === 'alphanumeric') {
            if (inputValue === '' || validateAlphanumeric(inputValue)) {
                onChange(e);
                setError(null);
            }
        } else if (validation === 'numeric') {
            if (inputValue === '' || /^\d+$/.test(inputValue)) {
                onChange(e);
                setError(null);
            }
       } else if (validation === 'phone') {
            if (inputValue === '' || validatePhone(inputValue)) {
                onChange(e);
                setError(null);
            }
      } else if (validation === 'textNumeric') {
          const sanitizedValue = inputValue.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]/g, '');
          e.target.value = sanitizedValue; // limpia el valor
          onChange(e);
          setError(null);
      } else {
          onChange(e);
          setError(null);
        }
      };

  let inputType = type;
  let inputProps = {};
  
  if (validation === 'numeric') {
    inputType = 'tel'; 
    inputProps.pattern = "[0-9]*"; 
    inputProps.inputMode = "numeric"; 
  } else if (validation === 'phone') {
    inputType = 'tel';
    inputProps.pattern = "[0-9]*";
    inputProps.inputMode = "numeric";
    inputProps.maxLength = 9; 
  }

    return(

        <div className= {`flex ${horizontal === true ? "flex-row items-center" : "flex-col"} justify-center w-full gap-2`}>
          {title && (
            <p className="font-itcbook text-[14px] md:text-[16px] text-[#111928] ">
            {title}
                {required && <span className="text-red-500">*</span>}
            </p>
          )}
          <input 
            type={inputType}
            name={name}
            value={value}
            placeholder={required && !title && placeholder ? `${placeholder} *` : placeholder}
            onChange={handleChange}
            maxLength={maxLength}
            required={required}
            className="bg-white focus:outline-none placeholder:text-[#6B7280] font-itcbook w-full placeholder:text-[14px] p-2 placeholder:font-itcbook text-[14px] border-[1px] h-[40px] border-[#D1D5DB] rounded-md"/>
        </div>

    );
};

export default InputField;